// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__187vn","footerContainerStaticPage":"Footer_footerContainerStaticPage__27sqf"};